import angular from 'angular';

angular.module('webTools').directive('wtCheckbox', function() {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        template: '<div class="checkbox left"></div>',
        link: function(scope, element, attributes) {
            if (attributes.bindToParent) {
                element.parent().bind('click', function() {
                    element.toggleClass('checked');
                })
            } else {
                element.bind('click', function() {
                    element.toggleClass('checked');
                })
            }
        }
    };
});

angular.module('webTools').directive('wtFormCheckbox', [function() {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            model: '=?'
        },
        template: '<div ng-class="{checked: model}" class="checkbox left">' +
                    '<input class="i-checkbox" style="display:none" ng-model="model" type="checkbox" />' +
                  '</div>',
        link: function(scope, element, attributes) {
            scope.test = true;

            element.children('input').bind('click', function(e) {
                e.stopPropagation();
            });

            if (attributes.bindToParent) {
                element.parent().bind('click', function(e) {
                    element.children('input').click();
                })
            } else {
                element.bind('click', function(e) {
                    element.children('input').click();
                })
            }
        }
    };
}]);

angular.module('webTools').directive('wtMasterCheckbox', function() {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        template: '<div class="master-checkbox left" ng-click="check()"></div>',
        link: function(scope, element, attributes) {

            scope.check = function(e) {
                if (element.hasClass('checked')) {
                    scope.uncheckAll();
                } else {
                    scope.checkAll();
                }
                element.toggleClass('checked');
            }

            scope.$watch(function() { return scope.allSelected(); },
                function(allSelected) {
                    allSelected ? element.addClass('checked') : element.removeClass('checked');
                }
            )
        }
    };
});